import Vue from 'vue';
import * as l10n from '@/constants/l10n';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';
import { localize } from '@/filters/localize';
export const PartCatalogueDetailsItemMeta = Vue.extend({
    functional: true,
    name: 'PartCatalogueDetailsItemMeta',
    props: {
        item: Object,
    },
    render(createElement, ctx) {
        const item = ctx.props.item;
        const metaItemsToRender = metaItemsFromItem(item).filter((metaItem) => !isNullOrWhitespace(metaItem.text));
        return (<ul class="small part-catalogue-details__item-meta">
                {metaItemsToRender.map((metaItem) => (<li>
                        {' '}
                        {metaItem.labelKey == null ? '' : `${localize(metaItem.labelKey)}:`} {metaItem.text}{' '}
                    </li>))}
            </ul>);
    },
});
function metaItemsFromItem(item) {
    return [
        {
            text: item.note,
        },
        {
            labelKey: l10n.PART_CATALOGUE.META.ASSEMBLY_NUMBER_FROM,
            text: item.assemblyNumbersRange,
        },
        {
            labelKey: l10n.PART_CATALOGUE.META.ENGINE_NUMBER_FROM,
            text: item.engineNumbersRange,
        },
    ];
}
//# sourceMappingURL=PartCatalogueDetailsItemMeta.jsx.map